(function () {
    'use strict';

    angular
        .module('Lavpop-store.services')
        .service('PaymentConditionService', PaymentConditionService)

    /** @ngInject */
    function PaymentConditionService(HttpService) {
        const PaymentConditionService = {
            getByProviderId: getByProviderId
        }

        return PaymentConditionService;

        function getByProviderId(providerId) {
            return HttpService.get(`/payment-conditions/provider/${providerId}`);
        }
    }
}());